export default __webpack_public_path__ + "static/10-adf0eea75f19ca1adb191479bb7b9470.png";